import QueryString from 'qs'
import { useEffect, useRef, useState } from 'react'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { getGuestOrderDetail, getOrderDetail } from '../../api/orderHistory'
import { getProductDetail } from '../../api/product'
import { Button } from '../../components/Button'
import { useCartContext } from '../../components/provider/CartProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/Order.css'
import { wcsPurchaseEvent } from '../../js/naverCTS'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { getParsedLocalStorageItem, plusComma } from '../../js/script'
import { purchase } from '../../js/pixelEvent'
import { useAppContext } from '../../components/provider/AppProvider'

// 이미지 경로
const imgURL = '/images'

/**
 * 주문 완료
 */

export default function OrderComplete() {
  const { isAppView } = useAppContext()
  const { setAddCart } = useCartContext()
  const { hasAccessToken } = useCommonContext()

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const params = QueryString.parse(window.location.search, {
    ignoreQueryPrefix: true,
  })

  const [orderItem, setOrderItem] = useState<any>()
  const [message, setMessage] = useState<string>('')
  const navigate = useNavigate()

  const isApp = useRef<boolean>(false)

  function eventPurchase(eventRevenue: any, eventValue: any) {
    window.AF('pba', 'event', {
      eventType: 'EVENT',
      eventName: 'purchase',
      eventRevenue: String(eventRevenue), //총 금액
      eventRevenueCurrency: 'KRW',
      eventValue: eventValue, //구매 제품 id 키값 1000자. 이 값을 초과하지 마십시오. 잘립니다.
    })
  }

  const getIsApp = async () => {
    const userAgent = navigator.userAgent
    const os = /android/i.test(userAgent) ? 'android' : 'ios'
    const isAppCheck = userAgent.includes('Aboutfishing/3')
    if (isAppCheck) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          targetFunc: 'getUserData',
        })
      )
      if (os === 'ios') {
        window.addEventListener(
          'loginUser',
          (event: any) => {
            isApp.current = !!event?.data.accessToken
          },
          false
        )
      } else {
        document.addEventListener(
          'loginUser',
          (event: any) => {
            isApp.current = !!event?.data.accessToken
          },
          false
        )
      }
    }
  }

  useEffect(() => {
    getIsApp()
  }, [])

  useEffect(() => {
    // orderNo를 안전하게 파싱
    const getOrderNoValue = (orderNoParam: any): string | undefined => {
      if (typeof orderNoParam === 'string') return orderNoParam
      if (Array.isArray(orderNoParam)) return orderNoParam[0]
      if (orderNoParam && typeof orderNoParam === 'object' && 'toString' in orderNoParam) return orderNoParam.toString()
      return undefined
    }

    const orderNoStr = queryParams.get('orderNo')
    const paramOrderNo = getOrderNoValue(params.orderNo)

    let orderNo: bigint | string | null = null
    if (orderNoStr && /^\d+$/.test(orderNoStr)) {
      orderNo = BigInt(orderNoStr)
    } else if (paramOrderNo && /^\d+$/.test(paramOrderNo)) {
      orderNo = BigInt(paramOrderNo)
    } else if (paramOrderNo) {
      orderNo = paramOrderNo // 숫자가 아니면 string으로 fallback
    } else {
      orderNo = null
    }

    const userAgent = navigator.userAgent
    const CheckToken = getParsedLocalStorageItem('accessToken')
    const isAppCheck = userAgent.includes('Aboutfishing/3')
    if (params.result === 'SUCCESS') {
      if (orderNo !== undefined) {
        if (!CheckToken) {
          // @ts-ignore
          getGuestOrderDetail(orderNo, params.guestToken)
            .then((res) => {
              setOrderItem(res.data)

              const array: any = []
              const optionArray: any = []
              const naverCTSItems: any = []
              let cartArray: any = []
              const productArray: any = []
              const cartList = getParsedLocalStorageItem('cartlist')
              const idObject: any = {}
              const pixelContent_ids: number[] = []
              const pixelContents: { name: string; quantity: number }[] = []
              const processOrderOptions = async () => {
                for (const partner of res.data.orderOptionsGroupByPartner) {
                  for (const deliveryGroup of partner.orderOptionsGroupByDelivery) {
                    for (let i = 0; i < deliveryGroup.orderOptions.length; i++) {
                      const option = deliveryGroup.orderOptions[i]
                      array.push(option.orderOptionNo)
                      idObject[i] = option.orderOptionNo
                      pixelContent_ids.push(option.optionManagementCd)
                      pixelContents.push({ name: option.optionTitle, quantity: option.orderCnt })
                      let category: any = []
                      try {
                        const response = await getProductDetail(option.productNo)
                        category = response.data.categories[1]?.categories

                        const obj = {
                          item_id: String(option.productNo),
                          item_name: option.productName,
                          affiliation: '어바웃피싱',
                          item_list_price: option.price?.salePrice,
                          item_selling_price: Number(option.price?.buyAmt) / Number(option.orderCnt),
                          price: String(option.price?.buyAmt),
                          item_total_discount: option.price?.immediateDiscountAmt,
                          discount: 0,
                          coupon: undefined,
                          item_brand: option?.brandName,
                          quantity: option.orderCnt,
                          item_category: category ? category[0]?.label : null,
                          item_category2: category ? category[1]?.label : null,
                          item_category3: category ? category[2]?.label : null,
                          item_variant: option.optionTitle,
                          item_list_id: undefined,
                          item_list_name: undefined,
                          promotion_id: undefined,
                          promotion_name: undefined,
                        }
                        const naverObj = {
                          id: option.productNo, //string 상품 id (필수)
                          name: option.productName, //string 상품 명 (필수)
                          category: category ? category[0]?.label : null, //string 카테고리 (필수값은 아니지만 꼭 넣어주세요)
                          quantity: option.orderCnt, //number 결제 수량 (필수)
                          payAmount: Number(option.price?.buyAmt), //number 결제 금액 (필수), 1개당 5만원, 3개 15만원
                          option: option.optionTitle,
                        }
                        naverCTSItems.push(naverObj)
                        optionArray.push(obj)
                        productArray.push(option.productNo)
                      } catch (error) {
                        console.error(`Failed to get product detail for product ${option.productNo}`, error)
                      }
                    }
                  }
                  purchase(
                    pixelContent_ids,
                    pixelContents as [{ name: string; quantity: number }],
                    res.data.lastOrderAmount?.payAmt - res.data?.lastOrderAmount?.deliveryAmt
                  )
                }

                // 카트 리스트 처리
                if (cartList.length !== 0) {
                  cartList.forEach((cartItem: any) => {
                    optionArray.forEach((option: any) => {
                      if (Number(cartItem.product) === Number(option.item_id)) {
                        option.item_list_id = cartItem.item_list_id
                        option.item_list_name = cartItem.item_list_name
                        option.promotion_id = cartItem.promotion_id
                        option.promotion_name = cartItem.promotion_name
                        cartArray.push(option)
                      }
                    })
                  })
                } else {
                  cartArray = optionArray
                }
                const updatedArray = cartArray.map((objItem: any) => {
                  // coupon 배열에서 현재 objItem의 item_id와 같은 productNo를 가진 객체 찾기
                  const matchingCoupon = res.data?.extraData?.productCoupon?.find(
                    (couponItem: any) => couponItem.productNo === objItem.item_id
                  )
                  // 일치하는 coupon 객체가 있으면 coupon과 discount 필드 업데이트
                  if (matchingCoupon) {
                    return {
                      ...objItem,
                      coupon: matchingCoupon.text,
                      discount: matchingCoupon.price,
                    }
                  }
                  // 일치하는 coupon이 없으면 원래 objItem 반환
                  return objItem
                })
                const viewItem: DataLayerArgs = {
                  dataLayer: {
                    event: 'purchase',
                    ecommerce: {
                      currency: 'KRW',
                      transaction_id: String(res.data.orderNo),
                      shipping: res.data?.lastOrderAmount?.deliveryAmt,
                      payment_type:
                        res.data.payType === 'NAVER_EASY_PAY'
                          ? '네이버페이'
                          : res.data.payType === 'KAKAO_PAY'
                          ? '카카오페이'
                          : res.data.payType === 'MY_PAY'
                          ? '어바웃피싱 페이'
                          : '신용 / 체크카드',
                      coupon: res.data.extraData.cartCoupon,
                      value: res.data.lastOrderAmount?.payAmt - res.data?.lastOrderAmount?.deliveryAmt,
                      items: updatedArray,
                      pay_back: res.data.accumulationAmtWhenBuyConfirm,
                      reserve_discount: res.data.lastOrderAmount?.subPayAmt,
                      order_discount: res.data.lastOrderAmount?.cartCouponDiscountAmt,
                    },
                  },
                }
                if (!isAppCheck) {
                  TagManager.dataLayer(viewItem)
                } else if (isAppCheck) {
                  sendSetAppsflyerEvent({
                    eventName: 'purchase',
                    eventType: {
                      currency: 'KRW',
                      transaction_id: String(res.data.orderNo),
                      shipping: res.data?.lastOrderAmount?.deliveryAmt,
                      payment_type:
                        res.data.payType === 'NAVER_EASY_PAY'
                          ? '네이버페이'
                          : res.data.payType === 'KAKAO_PAY'
                          ? '카카오페이'
                          : res.data.payType === 'MY_PAY'
                          ? '어바웃피싱 페이'
                          : '신용 / 체크카드',
                      coupon: res.data.extraData.cartCoupon,
                      value: res.data.lastOrderAmount?.payAmt - res.data?.lastOrderAmount?.deliveryAmt,
                      items: cartArray,
                      pay_back: res.data.accumulationAmtWhenBuyConfirm,
                      reserve_discount: res.data.lastOrderAmount?.subPayAmt,
                      order_discount: res.data.lastOrderAmount?.cartCouponDiscountAmt,
                    },
                  })
                  const appsarray: any = []
                  optionArray.map((el: any) => {
                    const obj = {
                      price: el.price,
                      item_id: el.item_id,
                      item_name: el.item_name,
                      quantity: el.quantity,
                    }
                    appsarray.push(obj)
                  })
                  sendSetAppsflyerEvent({
                    eventName: 'af_purchase',
                    eventType: {
                      af_currency: 'KRW',
                      af_content_id: res.data.orderNo,
                      af_receipt_id: res.data.orderNo,
                      af_order_id: res.data.orderNo,
                      af_revenue: res.data.lastOrderAmount?.payAmt,
                      af_price: res.data.lastOrderAmount?.payAmt,
                      af_quantity: optionArray.length + 1 || 1,
                    },
                  })
                }
              }
              // 호출
              processOrderOptions()
              eventPurchase(res.data.lastOrderAmount?.payAmt, idObject)

              const purchaseResult = {
                id: orderNo as string, // 구매 id (필수): 주문번호 id
                // items 배열에 각 구매한 아이템들을 담아줍니다. 아이템 옵션들의 값은 전부 필수로 채어넣어주세요
                items: naverCTSItems,
                value: res.data.lastOrderAmount?.payAmt, // 총 결제 금액 (필수: 배송비 포함), 15만 + 20만 + 3천원(배송비) = 353000원
              }

              //네이버CTS
              if (purchaseResult) {
                setTimeout(() => {
                  wcsPurchaseEvent(purchaseResult)
                }, 300)
              }
              setTimeout(() => {
                window.sessionStorage.setItem('guestCart', JSON.stringify([]))
                window.sessionStorage.setItem('cart', JSON.stringify([]))
                window.localStorage.setItem('cartlist', JSON.stringify([]))
              }, 300)
            })
            .catch((err) => console.log(err))
        } else {
          // @ts-ignore
          getOrderDetail(orderNo)
            .then((res) => {
              setOrderItem(res.data)
              const array: any = []
              const optionArray: any = []
              const naverCTSItems: any = []
              let cartArray: any = []
              const productArray: any = []

              const cartList = getParsedLocalStorageItem('cartlist')
              const idObject: any = {}
              const pixelContent_ids: number[] = []
              const pixelContents: { name: string; quantity: number }[] = []
              const processOrderOptions = async () => {
                for (const partner of res.data.orderOptionsGroupByPartner) {
                  for (const deliveryGroup of partner.orderOptionsGroupByDelivery) {
                    for (let i = 0; i < deliveryGroup.orderOptions.length; i++) {
                      const option = deliveryGroup.orderOptions[i]
                      pixelContent_ids.push(option.optionManagementCd)
                      pixelContents.push({ name: option.optionTitle, quantity: option.orderCnt })
                      idObject[i] = option.orderOptionNo
                      let category: any = []
                      try {
                        const response = await getProductDetail(option.productNo)
                        category = response.data.categories[1]?.categories
                        const obj = {
                          item_id: String(option.productNo),
                          item_name: option.productName,
                          affiliation: '어바웃피싱',
                          item_list_price: option.price?.salePrice,
                          item_selling_price: Number(option.price?.buyAmt) / Number(option.orderCnt),
                          price: String(option.price?.buyAmt),
                          item_total_discount: option.price?.immediateDiscountAmt,
                          discount: 0,
                          coupon: undefined,
                          item_brand: option?.brandName,
                          quantity: option.orderCnt,
                          item_category: category ? category[0]?.label : null,
                          item_category2: category ? category[1]?.label : null,
                          item_category3: category ? category[2]?.label : null,
                          item_variant: option.optionTitle,
                          item_list_id: undefined,
                          item_list_name: undefined,
                          promotion_id: undefined,
                          promotion_name: undefined,
                        }
                        const naverObj = {
                          id: option.productNo, //string 상품 id (필수)
                          name: option.productName, //string 상품 명 (필수)
                          category: category ? category[0]?.label : null, //string 카테고리 (필수값은 아니지만 꼭 넣어주세요)
                          quantity: option.orderCnt, //number 결제 수량 (필수)
                          payAmount: Number(option.price?.buyAmt), //number 결제 금액 (필수), 1개당 5만원, 3개 15만원
                          option: option.optionTitle,
                        }
                        naverCTSItems.push(naverObj)
                        optionArray.push(obj)
                        productArray.push(option.productNo)
                      } catch (error) {
                        console.error(`Failed to get product detail for product ${option.productNo}`, error)
                      }
                    }
                  }
                  purchase(
                    pixelContent_ids,
                    pixelContents as [{ name: string; quantity: number }],
                    res.data.lastOrderAmount?.payAmt - res.data?.lastOrderAmount?.deliveryAmt
                  )
                }
                // 카트 리스트 처리
                if (cartList.length !== 0) {
                  cartList.forEach((cartItem: any) => {
                    optionArray.forEach((option: any) => {
                      if (Number(cartItem.product) === Number(option.item_id)) {
                        option.item_list_id = cartItem.item_list_id
                        option.item_list_name = cartItem.item_list_name
                        option.promotion_id = cartItem.promotion_id
                        option.promotion_name = cartItem.promotion_name
                        cartArray.push(option)
                      }
                    })
                  })
                } else {
                  cartArray = optionArray
                }
                const updatedArray = cartArray.map((objItem: any) => {
                  // coupon 배열에서 현재 objItem의 item_id와 같은 productNo를 가진 객체 찾기
                  const productCoupon = res.data?.extraData?.productCoupon
                  const matchingCoupon = Array.isArray(productCoupon)
                    ? productCoupon.find((couponItem: any) => couponItem.productNo === objItem.item_id)
                    : undefined
                  // 일치하는 coupon 객체가 있으면 coupon과 discount 필드 업데이트
                  if (matchingCoupon) {
                    return {
                      ...objItem,
                      coupon: matchingCoupon.text,
                      discount: matchingCoupon.price,
                    }
                  }
                  // 일치하는 coupon이 없으면 원래 objItem 반환
                  return objItem
                })
                const viewItem: DataLayerArgs = {
                  dataLayer: {
                    event: 'purchase',
                    ecommerce: {
                      currency: 'KRW',
                      transaction_id: String(res.data.orderNo),
                      shipping: res.data?.lastOrderAmount?.deliveryAmt,
                      payment_type:
                        res.data.payType === 'NAVER_EASY_PAY'
                          ? '네이버페이'
                          : res.data.payType === 'KAKAO_PAY'
                          ? '카카오페이'
                          : res.data.payType === 'MY_PAY'
                          ? '어바웃피싱 페이'
                          : '신용 / 체크카드',
                      coupon: res.data.extraData.cartCoupon,
                      value: res.data.lastOrderAmount?.payAmt - res.data?.lastOrderAmount?.deliveryAmt,
                      items: updatedArray,
                      pay_back: res.data.accumulationAmtWhenBuyConfirm,
                      reserve_discount: res.data.lastOrderAmount?.subPayAmt,
                      order_discount: res.data.lastOrderAmount?.cartCouponDiscountAmt,
                    },
                  },
                }
                if (!isAppCheck) {
                  TagManager.dataLayer(viewItem)
                } else if (isAppCheck) {
                  sendSetAppsflyerEvent({
                    eventName: 'purchase',
                    eventType: {
                      currency: 'KRW',
                      transaction_id: String(res.data.orderNo),
                      shipping: res.data?.lastOrderAmount?.deliveryAmt,
                      payment_type:
                        res.data.payType === 'NAVER_EASY_PAY'
                          ? '네이버페이'
                          : res.data.payType === 'KAKAO_PAY'
                          ? '카카오페이'
                          : res.data.payType === 'MY_PAY'
                          ? '어바웃피싱 페이'
                          : '신용 / 체크카드',
                      coupon: res.data.extraData.cartCoupon,
                      value: res.data.lastOrderAmount?.payAmt - res.data?.lastOrderAmount?.deliveryAmt,
                      items: cartArray,
                      pay_back: res.data.accumulationAmtWhenBuyConfirm,
                      reserve_discount: res.data.lastOrderAmount?.subPayAmt,
                      order_discount: res.data.lastOrderAmount?.cartCouponDiscountAmt,
                    },
                  })
                  const appsarray: any = []
                  optionArray.map((el: any) => {
                    const obj = {
                      price: el.price,
                      item_id: el.item_id,
                      item_name: el.item_name,
                      quantity: el.quantity,
                    }
                    appsarray.push(obj)
                  })
                  sendSetAppsflyerEvent({
                    eventName: 'af_purchase',
                    eventType: {
                      af_currency: 'KRW',
                      af_content_id: res.data.orderNo,
                      af_receipt_id: res.data.orderNo,
                      af_order_id: res.data.orderNo,
                      af_revenue: res.data.lastOrderAmount?.payAmt,
                      af_price: res.data.lastOrderAmount?.payAmt,
                      af_quantity: optionArray.length + 1 || 1,
                    },
                  })
                }
              }
              // 호출
              processOrderOptions()
              //isApp 함수 미실행됨
              eventPurchase(res.data.lastOrderAmount?.payAmt - res.data?.lastOrderAmount?.deliveryAmt, idObject)

              // 네이버 CTS용
              const purchaseResult = {
                id: orderNo as string, // 구매 id (필수): 주문번호 id
                // items 배열에 각 구매한 아이템들을 담아줍니다. 아이템 옵션들의 값은 전부 필수로 채어넣어주세요
                items: naverCTSItems,
                value: res.data.lastOrderAmount?.payAmt - res.data?.lastOrderAmount?.deliveryAmt, // 총 결제 금액 (필수: 배송비 포함), 15만 + 20만 + 3천원(배송비) = 353000원
              }

              //네이버CTS
              if (purchaseResult) {
                setTimeout(() => {
                  wcsPurchaseEvent(purchaseResult)
                }, 300)
              }

              setTimeout(() => {
                window.sessionStorage.setItem('guestCart', JSON.stringify([]))
                window.sessionStorage.setItem('cart', JSON.stringify([]))
                window.localStorage.setItem('cartlist', JSON.stringify([]))
              }, 300)
            })
            .catch((err) => console.log(err))
        }
      }
      setAddCart((prev: boolean) => !prev)
    } else {
      if (params.message !== undefined) {
        // @ts-ignore를 제거하고 타입 검사 추가
        const orderCancelMessage = params.message
        if (typeof orderCancelMessage === 'string' && orderCancelMessage.includes('kakao pay confirm error')) {
          const errCode = orderCancelMessage.split('response: ')[1]
          const errCodeParse = JSON.parse(errCode).code
          // const errCode2Parse = JSON.parse(errCode)?.extras?.method_result_code;
          // if(String(errCode2Parse) === '4510'){
          //   setMessage("한도 초과") // 한도 초과
          // }
          // else if(String(errCode2Parse) === '4511'){
          //   setMessage("잔액 부족인데 다른 계좌로 시도해주세요") // 잔액 부족인데 다른 계좌로 시도해주세요
          // }
          // else {
          if (String(errCodeParse) === '-7')
            setMessage('카카오페이 서비스 점검 중입니다. 일정 시간 후 재결제를 진행해 주세요.')
          // else if(String(errCodeParse) === '-780') setMessage("잔액 부족"); // 잔액 부족
          else if (String(errCodeParse) === '-10')
            setMessage('결제 시도 횟수가 많아 오류가 발생했습니다. 일정 시간 후 재결제를 진행해 주세요.')
          else if (String(errCodeParse) === '-723') setMessage('결제 시간을 초과했습니다. 재결제를 진행해 주세요.')
          else if (String(errCodeParse) === '-761')
            setMessage('카카오 페이에 가입하지 않으셨습니다. 카카오 페이를 가입 후 결제를 시도해 주세요.')
          else if (String(errCodeParse) === '-950') setMessage('결제 시간을 초과했습니다. 재결제를 진행해 주세요.')
          else if (String(errCodeParse) === '-9798')
            setMessage('카카오 페이 서비스 점검 중입니다. 일정 시간 후 재결제를 진행해 주세요.')
          else setMessage('결제 중 오류가 발생했습니다. 재결제를 진행해 주세요.')
          // }
        } else {
          setMessage(orderCancelMessage as string)
        }
      }
    }
  }, [location])

  return (
    <>
      <div className='main_wrap' style={{ justifyContent: 'center', minHeight: 'calc(100vh - 352px)' }}>
        <div className='contents_wrap'>
          <div className='order_complete_wrap'>
            {params.result === 'SUCCESS' ? (
              <>
                <PageTitle>주문 완료</PageTitle>
                <div className='order_complete_header'>
                  <img src={`${imgURL}/icon_complete.png`} alt='' />
                  <p>
                    주문이 완료되었어요
                    <br />
                    상품을 빠르게 배송해 드릴게요
                  </p>
                </div>

                <div className='order_complete_contents'>
                  <strong>결제 정보</strong>
                  <div className='order_info_list'>
                    <dl>
                      <dt>결제일시</dt>
                      <dd>{orderItem?.orderYmdt.replaceAll('-', '.')}</dd>
                    </dl>
                    <dl>
                      <dt>주문번호</dt>
                      <dd>{orderItem?.orderNo ? orderItem.orderNo.toString() : ''}</dd>
                    </dl>
                    <dl>
                      <dt>정상가</dt>
                      <dd>{plusComma(orderItem?.lastOrderAmount?.standardAmt)}원</dd>
                    </dl>
                    <dl>
                      <dt>상품 할인</dt>
                      <dd>- {plusComma(orderItem?.lastOrderAmount?.immediateDiscountAmt)}원</dd>
                    </dl>
                    <dl>
                      <dt>쿠폰 할인</dt>
                      <dd>
                        {plusComma(
                          orderItem?.lastOrderAmount?.cartCouponDiscountAmt +
                            orderItem?.lastOrderAmount?.productCouponDiscountAmt
                        )}
                        원
                      </dd>
                    </dl>
                    <dl>
                      <dt>적립금 할인</dt>
                      <dd>{plusComma(orderItem?.lastOrderAmount?.subPayAmt)}원</dd>
                    </dl>
                    <dl>
                      <dt>배송비</dt>
                      <dd>+ {plusComma(orderItem?.lastOrderAmount?.deliveryAmt)}원</dd>
                    </dl>
                    <dl>
                      <dt>할인금액 합계</dt>
                      <dd>
                        -{' '}
                        {plusComma(
                          orderItem?.lastOrderAmount?.immediateDiscountAmt +
                            orderItem?.lastOrderAmount?.additionalDiscountAmt +
                            orderItem?.lastOrderAmount?.cartCouponDiscountAmt +
                            orderItem?.lastOrderAmount?.productCouponDiscountAmt +
                            orderItem?.lastOrderAmount?.deliveryCouponDiscountAmt +
                            orderItem?.lastOrderAmount?.subPayAmt
                        )}
                        원
                      </dd>
                    </dl>
                    <dl>
                      <dt>총 결제금액</dt>
                      <dd>{plusComma(orderItem?.lastOrderAmount?.chargeAmt)}원</dd>
                    </dl>
                  </div>
                </div>
                <div className='order_complete_buttons'>
                  <a
                    className='order_list'
                    onClick={() => {
                      if (!hasAccessToken) {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/guestorderlist`,
                          })
                        } else {
                          navigate(`/guestorderlist`)
                        }
                      } else {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/orderlistinquiry`,
                          })
                        } else {
                          navigate(`/orderlistinquiry`)
                        }
                      }
                    }}
                  >
                    주문내역 보기
                  </a>
                  <div
                    className='go_home'
                    onClick={() => {
                      if (isAppView) {
                        RNPostMessage(AFWebLinkType.onClose, { eventType: 2 })
                      } else {
                        navigate(`/`)
                      }
                    }}
                  >
                    홈으로 돌아가기
                  </div>
                </div>
              </>
            ) : (
              <NoContentWrap style={{ height: '100%', alignItems: 'center' }}>
                <NoContentContentWrap style={{ width: '80%', textAlign: 'center', height: '100%' }}>
                  <NoContentTitle style={{ wordBreak: 'keep-all' }}>{message}</NoContentTitle>
                  <NoContentBtn
                    onClick={() => {
                      if (isAppView) {
                        RNPostMessage(AFWebLinkType.onClose, { eventType: 2 })
                      } else {
                        navigate('/')
                      }
                    }}
                  >
                    쇼핑 계속하기
                  </NoContentBtn>
                </NoContentContentWrap>
              </NoContentWrap>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
export const NoContentWrap = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  @media screen and (min-width: 768px) {
    display: flex;
    padding: 0;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`

export const NoContentContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const NoContentTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`

export const NoContentBtn = styled(Button)`
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 35px;
  color: var(--colWhite);
  background: var(--colBlack);
  border-radius: 76px;
  line-height: 20px;
  margin-top: 20px;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    padding: 14px 40px;
    margin-top: 32px;
    cursor: pointer;
  }
`
